import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";
import { eBayIntegrationDelete } from "src/apiService/modules/ebay";
import { StatefulLoadableButton } from "src/components/LoadableButton";
import { EBayIntegration } from "src/interfaces/plaidIntegration.interface";
import usePrevious from "src/utils/usePrevious";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

export interface DeleteIntegrationDialogContentProps {
  integration: Pick<EBayIntegration, "id" | "name">;
  onClose: () => void;
  deleteIntegration?: (id: string) => Promise<void>;
}

function DeleteIntegrationDialogContent({
  integration,
  onClose,
  deleteIntegration = eBayIntegrationDelete,
}: DeleteIntegrationDialogContentProps) {
  const classes = useStyles();
  return (
    <>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the {integration.name} integration?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StatefulLoadableButton
          variant="contained"
          onClick={async () => {
            await deleteIntegration(integration.id);
            onClose();
          }}
          className={classes.deleteButton}
          autoFocus
        >
          Delete
        </StatefulLoadableButton>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </>
  );
}

export interface DeleteIntegrationDialogProps {
  integration?: Pick<EBayIntegration, "id" | "name">;
  onClose: () => void;
  deleteIntegration?: DeleteIntegrationDialogContentProps["deleteIntegration"];
}

function DeleteIntegrationDialog({
  integration,
  onClose,
  deleteIntegration,
}: DeleteIntegrationDialogProps) {
  const prev = usePrevious(integration);
  return (
    <Dialog open={!!integration} onClose={onClose}>
      <DialogTitle>Delete Integration</DialogTitle>
      {!!prev && (
        <DeleteIntegrationDialogContent
          integration={prev}
          onClose={onClose}
          deleteIntegration={deleteIntegration}
        />
      )}
    </Dialog>
  );
}
export default DeleteIntegrationDialog;
